import React, { Component } from 'react';
import propTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

import { noop } from 'lib/noop';
import { PrimaryButton } from 'ui/Components';

import styles from './AMPModal.css';
import AssetArea from './AssetArea';
import ControlArea from './ControlArea';
import { AMP_TABS } from '../const';

/**
 * a modal to query assets from amp
 */
export default class AMPModal extends Component {
  static propTypes = {
    buttonLabel: propTypes.string,
    changeQueryDataFilter: propTypes.func,
    className: propTypes.string,
    clearQueryData: propTypes.func,
    data: propTypes.arrayOf(propTypes.object),
    'data-test-id': propTypes.string,
    filter: propTypes.string,
    isFetching: propTypes.bool,
    isReadonly: propTypes.bool,
    onChange: propTypes.func.isRequired,
    queryByAssetId: propTypes.func,
    queryByWorkfrontId: propTypes.func
  };

  static defaultProps = {
    buttonLabel: 'Select',
    changeQueryDataFilter: noop,
    className: '',
    clearQueryData: noop,
    data: [],
    'data-test-id': '',
    filter: '',
    isFetching: false,
    isReadonly: false,
    queryByAssetId: noop,
    queryByWorkfrontId: noop
  };

  state = {
    activeTab: AMP_TABS.WEB_READY,
    asset: null,
    modal: false
  };

  /**
   * change active tab based on event target text
   * @param {Event} event - click event
   */
  changeActiveTab = event => {
    this.setState({ activeTab: event.target.innerText });
  };

  /**
   * update `asset` internal state with given asset
   * @param {URL} asset - selected asset
   */
  handleAsset = asset => {
    this.setState({ asset });
  };

  /**
   * call `onChange` prop with asset internal state
   */
  handleInsert = () => {
    const { onChange } = this.props;
    const { asset } = this.state;
    onChange(asset.toString());
    this.toggle();
  };

  /**
   * toggle modal open/close
   */
  toggle = () => {
    const { clearQueryData } = this.props;
    this.setState(({ modal }) => {
      const newState = { modal: !modal };

      if (!newState.modal) {
        newState.asset = null;
        clearQueryData();
      }

      return newState;
    });
  };

  /**
   * render a button that opens the amp modal
   * @returns {Component} React Component for Modal Content.
   */
  render() {
    const {
      buttonLabel,
      changeQueryDataFilter,
      className,
      clearQueryData,
      data,
      'data-test-id': testId,
      filter,
      isFetching,
      isReadonly,
      queryByAssetId,
      queryByWorkfrontId
    } = this.props;
    const { activeTab, asset, modal } = this.state;

    return (
      <div className={`d-inline-block ${className}`}>
        <PrimaryButton
          className="rounded"
          color="primary"
          data-test-id={testId}
          disabled={isReadonly}
          onClick={this.toggle}
        >
          {buttonLabel}
        </PrimaryButton>
        <Modal
          className={styles.modal}
          isOpen={modal}
          toggle={this.toggle}
          zIndex={5}
          data-test-id="amp-modal-main"
        >
          <ModalHeader toggle={this.toggle}>AMP Connector</ModalHeader>
          <ModalBody className="d-flex p-0">
            <ControlArea
              activeTab={activeTab}
              changeActiveTab={this.changeActiveTab}
              changeFilter={changeQueryDataFilter}
              clearQueryData={clearQueryData}
              filter={filter}
              onAsset={this.handleAsset}
              queryByAssetId={queryByAssetId}
              queryByWorkfrontId={queryByWorkfrontId}
            />
            <AssetArea
              asset={asset}
              cardData={data}
              isFetching={isFetching}
              isPlacement={activeTab === AMP_TABS.PLACEMENT_ONLY}
              onAsset={this.handleAsset}
              onCancel={this.toggle}
              onInsert={this.handleInsert}
            />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
